import { Component, OnInit , ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';

@Component({
  selector: 'app-game-about',
  templateUrl: './game-about.component.html',
  styleUrls: ['./game-about.component.scss']
})
export class GameAboutComponent implements OnInit {
  url: string;
  game: any;
  categories: any;
  cont: any;
  private routeObs: Subscription;


  public games = [
    {
      title: 'Incendios Forestales',
      img: '/assets/games/fuego-04.jpg',
      theme: 1,
      link: 'juego-inicio/incendios'
    },
    {
      title: 'Humedales',
      theme: 2,
      img: '/assets/games/fuego-01.jpg',
      link: 'juego-inicio/humedales'
    },
    {
      title: 'Criaturas amazónicas',
      theme: 3,
      img: '/assets/games/fuego-02.jpg',
      link: 'http://bufeo.wwfbolivia.org/'
    }
  ]


  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public api: RestapiService
  ) {

    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.loadContent()
  }

  loadContent() {
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.api.getdata('websection', {
      filters: { name: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEBSECTION', res);
        this.cont = res.result.data[0];
      }
      else {
        console.log('ERROR ON LOAD', this.url);
      }
    })
  }
}
